module.exports = __webpack_public_path__ + "img/banner2_4New.af57dc7c.png";